import useCarProductionTimeDelete from 'api/carProductionTime/useCarProductionTimeDelete/useCarProductionTimeDelete';
import useCarProductionTimeList from 'api/carProductionTime/useCarProductionTimeList/useCarProductionTimeList';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import CarProductionTimeEdit from 'components/shared/Modals/carProductionTime/CarProductionTimeEdit/CarProductionTimeEdit';
import CarProductionTimeInsert from 'components/shared/Modals/carProductionTime/CarProductionTimeInsert/CarProductionTimeInsert';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useCarProductionTimeTableColumns from 'hooks/carProductionTime/useCarProductionTimeTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const CarProductionTime = () => {
  const { guid } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getCarProductionTimeList, loading, carProductionTimeList, pageRef] =
    useCarProductionTimeList(guid);

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenCarProductionTime, setEditChosenCarProductionTime] =
    useState({});

  const [deleteRequest] = useCarProductionTimeDelete();

  const tableRef = useRef(null);
  const { can } = usePermissions();

  const manufacturingDatePermissions =
    permissions.general.categories.globalSettings.coddingSettings.carFactory
      .brands.models.series.manufacturingDate;

  const canCreate = can(manufacturingDatePermissions.create);
  const canEdit = can(manufacturingDatePermissions.edit);
  const canDelete = can(manufacturingDatePermissions.delete);

  useEffect(() => {
    getCarProductionTimeList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getCarProductionTimeList({ page, count: pageSize });
  }, [pageSize]);

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenCarProductionTime(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const [columnsData] = useCarProductionTimeTableColumns(
    deleteItem,
    editItem,
    tableRef,
    {
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(
      id,
      getCarProductionTimeList,
      setIsDeleteModalOpen,
      setDeleteLoading,
    );
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getCarProductionTimeList({
      page: pageNumber,
      count: pageSize,
      term: lastSearch,
    });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getCarProductionTimeList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(carProductionTimeList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={carProductionTimeList[page]}
          rows={carProductionTimeList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت سال ساخت خودرو' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canCreate ? (
        <CarProductionTimeInsert
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          getCarProductionTimeList={getCarProductionTimeList}
          seriesGuid={guid}
        />
      ) : null}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canEdit ? (
        <CarProductionTimeEdit
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          chosenCarProductionTime={editChosenCarProductionTime}
          getCarProductionTimeList={getCarProductionTimeList}
        />
      ) : null}
    </>
  );
};

export default CarProductionTime;
